import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_addAdvanceLog = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.ADVANCE_LOG_URL}`, data);
};
